import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Flex } from '../../atoms';
import Box from '../../atoms/Box/Box';

const StyledBtn = styled(Flex)`
  align-items: top;
  justify-content: center;
  padding: 10px 15px;
  height: 100%;
  background: ${themeGet('colors.brand.blue')};
  color: ${themeGet('colors.white')};
  font-weight: bold;
  white-space: nowrap;
  flex: 1;
`;

const MobileFilterBtnBlock = ({ Icon, label, ...props }) => (
  <StyledBtn {...props} role="button">
    <Box mr={6}>{label}</Box>
    <Icon color="white" />
  </StyledBtn>
);

MobileFilterBtnBlock.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  label: PropTypes.string,
};

export default MobileFilterBtnBlock;
